import React from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { DatePicker, Icon } from '@livable/saas-react-components';
import { addMonths, format, isAfter, isBefore, startOfToday, subMonths } from 'date-fns';
import useStyles from './styles';
const LOCKED_STATUSES = new Set(['Paused', 'Canceled']);
const WARNING_MONTHS = 6;
const DATE_FORMAT = 'MM/dd/yy';
export const isStartDateLocked = (isEdit, status) => isEdit && LOCKED_STATUSES.has(status);
const isFarFromToday = date => {
  if (!date) return false;
  const today = startOfToday();
  return isBefore(date, subMonths(today, WARNING_MONTHS)) || isAfter(date, addMonths(today, WARNING_MONTHS));
};
export const SubscriptionStartDate = _ref => {
  let value = _ref.value,
    onChange = _ref.onChange,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  const classes = useStyles();
  const showWarning = !disabled && isFarFromToday(value);
  return /*#__PURE__*/React.createElement(Box, {
    className: classes.section
  }, /*#__PURE__*/React.createElement(Box, {
    className: classes.field
  }, disabled ? /*#__PURE__*/React.createElement(TextField, {
    label: "Start Date",
    value: value ? format(value, DATE_FORMAT) : '',
    disabled: true,
    fullWidth: true,
    InputProps: {
      style: {
        paddingRight: '14px'
      },
      endAdornment: /*#__PURE__*/React.createElement(Icon, {
        type: "calendar-picker",
        color: "disabled"
      })
    }
  }) : /*#__PURE__*/React.createElement(DatePicker, {
    format: DATE_FORMAT,
    label: "Start Date",
    value: value,
    onChange: onChange
  })), showWarning && /*#__PURE__*/React.createElement(Box, {
    className: classes.warning
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "alert",
    fontSize: "small",
    color: "warning"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    sx: {
      color: 'warning.dark'
    }
  }, "More than ", WARNING_MONTHS, " months from today \u2014 please confirm this is intentional.")));
};